//#region Angular Imports

import { StateProvider, StateService } from '@uirouter/angularjs'

//#endregion

import { Activity, Enums } from '../../models/common/'

import { default as apiModule, Api, LocalDictionaryFactory } from '../api/api.module'
import { default as commonModule, LoggerService } from '../common/common.module'

import { MenuItem } from '../common/sidebar-menu/common.sidebar-menu.directive'

import { ConfigHelper, IUserSession, UserSession } from '../../helpers'
import { OpOperator } from '../../models/core'

import { SERVICES_MODULE_NAME } from './../../services'
import { SYSTEM_SERVICE_PROVIDER_NAME, SystemServiceProvider, $SCOPE_SERVICE_NAME, $STATE_SERVICE_NAME, $TIMEOUT_SERVICE_NAME, SYSTEM_SERVICE_NAME, SystemService } from '../../services/system'

import { GRID_SERVICE_NAME, GridService } from '../../services/grid'
import { OperatorGroupController } from './operator-group.controller'
import { OperatorCreateEditDirective } from './create-edit/operator-group-create-edit-popup.directive'
import { OperatorGroupDetailsDirective } from './details/operator-group-details.directive'
import { OperatorGroupHelper } from './operator-group-helper'
import { USER_SESSION_SERVICE_NAME } from '../../services/user-session'

//#region Asset Imports

import './operator-group.scss'
import * as TEMPLATE from './operator-group.tpl.html'

//#endregion

// #region Consts

const CONTROLLER_NAME: string = 'OperatorGroupController'
const CREATE_EDIT_DIRECTIVE_NAME: string = 'operatorGroupCreateEdit'
const DETAILS_DIRECTIVE_NAME: string = 'operatorGroupDetails'
const MODULE_NAME: string = 'simax.operator-group'
const MODULE_NAME_LOCALIZATION_TEXT: string = 'OPERATOR_GROUP'
const STATE_NAME: string = 'operatorGroup'
const STATE_URL: string = '/operatorgroup'

// #endregion


// #region Setup


const module = angular.module(MODULE_NAME, [commonModule, apiModule, SERVICES_MODULE_NAME])

module.controller(CONTROLLER_NAME, [$SCOPE_SERVICE_NAME, $STATE_SERVICE_NAME, $TIMEOUT_SERVICE_NAME, 'api', 'logger', 'localDictionary', USER_SESSION_SERVICE_NAME, GRID_SERVICE_NAME, SYSTEM_SERVICE_NAME, (
    $scope,
    $state: StateService,
    $timeout: ng.ITimeoutService,
    api: Api,
    logger: LoggerService,
    localDictionary: LocalDictionaryFactory,
    userSession: IUserSession,
    gridService: GridService,
    systemService: SystemService
) => new OperatorGroupController(
    $scope,
    $state,
    $timeout,
    api,
    logger,
    localDictionary,
    userSession,
    gridService,
    systemService,
    OperatorGroupHelper.SIMAX_MODULE_NAME,
    OperatorGroupHelper.REFERENCE_TYPE
)])

module.directive(DETAILS_DIRECTIVE_NAME, [() => new OperatorGroupDetailsDirective()])
module.directive(CREATE_EDIT_DIRECTIVE_NAME, [() => new OperatorCreateEditDirective()])

module.config(['$stateProvider', 'userSessionProvider', SYSTEM_SERVICE_PROVIDER_NAME, (
    $stateProvider: StateProvider,
    userSessionProvider: UserSession,
    systemServiceProvider: SystemServiceProvider
) => {

    systemServiceProvider.registerDetailsComponent({
        key: 'Operator_Group_IdOperatorGroup',
        componentName: DETAILS_DIRECTIVE_NAME
    })

    userSessionProvider
        .getLoggedOperatorAsync()
        .then((loggedOperator: OpOperator) => {
            if (loggedOperator.hasPermission(Activity.OPERATOR_GROUP_LIST)
                && !loggedOperator.hasPermission(Activity.OPERATOR_GROUP_MODULE_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.OperatorGroupModule)) {

                MenuItem.addMenuItem(
                    ConfigHelper.getIconName(ConfigHelper.Icon.USER_OUTLINE),
                    'operatorGroup',
                    MODULE_NAME_LOCALIZATION_TEXT,
                    STATE_NAME
                )

                $stateProvider.state(STATE_NAME, {
                    url: STATE_URL,
                    controller: CONTROLLER_NAME,
                    template: TEMPLATE,
                    params: { ids: null }
                })
            }
        })
}])

export default MODULE_NAME

// #endregion